import { gql, useMutation } from '@apollo/client';

import type { DeleteDependentMutation, DeleteDependentMutationVariables } from './__generated__/useDeleteDependent.gql';

const DELETE_DEPENDENT = gql`
  mutation DeleteDependent($input: DeleteDependantInput!) {
    deleteDependant(input: $input)
  }
`;

/**
 * Removes an existing `Dependant` row. The backend cascade-deletes the
 * caregiver edge, any partnerships, residences, and vehicles tied to the
 * dependent — so this is the single mutation needed when a slot is dropped
 * from the loved-ones onboarding flow.
 *
 * Returns the deleted id as a bare scalar, which Apollo's normalized cache
 * can't reconcile against the family's `caregiverRelationships` list — so
 * callers must refetch the query that reads them (e.g.
 * `useDependents().refetch()`) after a delete. The review step does
 * this once, after its delete/create phases.
 */
export const useDeleteDependent = () => {
  return useMutation<DeleteDependentMutation, DeleteDependentMutationVariables>(DELETE_DEPENDENT);
};
